class MCartAddons extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      zipCode: '[name="address[zip]"]',
      province: '[name="address[province]"]',
      country: '[name="address[country]"]',
      addressForm: '[data-address="root"]',
      shippingMessage: ".m-cart-addon__shipping-rate",
      cartDiscountCode: '[name="discount"]',
      cartDiscountCodeNoti: "[data-discount-noti]",
      cartNote: '[name="note"]',
      saveAddonButton: ".m-cart-addon--save",
      closeAddonButton: ".m-cart-addon--close",
      calcShippingButton: ".m-cart-addon--calculate",
      triggerAddonButton: ".m-cart-addon--trigger-button",
      devliveryTime: '[name="attributes[Delivery time]"]',
    };

    this.cartWrapper = document.querySelector(".m-cart-drawer");
    this.isCartPage = MinimogSettings.templateName === "cart";
    if (this.isCartPage) {
      this.cartWrapper = document.querySelector(".m-cart__footer--wrapper");
    }
    this.initAddress = false;
    this.cartOverlay = this.cartWrapper.querySelector(".m-cart__overlay");
    this.domNodes = queryDomNodes(this.selectors, this);
    this.rootUrl = window.Shopify.routes.root;
    this.discountCodeKey = "minimog-discount-code";
    this.deliveryCodeKey = "minimog-delivery-code";
    this.init();
  }

  init() {
    const { cartDiscountCode, cartDiscountCodeNoti, devliveryTime } = this.domNodes;
    addEventDelegate({
      selector: this.selectors.triggerAddonButton,
      context: this,
      handler: (e, addonButton) => {
        e.preventDefault();
        if (this.isCartPage) {
          const addonCurrentActive = document.querySelector(".m-cart-addon__body.open");
          if (addonCurrentActive) addonCurrentActive.classList.remove("open");
        }
        const { open: addonTarget } = addonButton.dataset;
        const addonNode = this.cartWrapper.querySelector(`#m-addons-${addonTarget}`);
        this.removeActiveAllButton();
        addonButton.classList.add("active");
        addonNode && addonNode.classList.add("open");
        this.cartOverlay && this.cartOverlay.classList.add("open");
        this.openAddon = addonNode;

        if (addonTarget === "shipping") {
          fetchSection("country-options", { url: window.MinimogSettings.base_url })
            .then((html) => {
              const select = html.querySelector("#AddressCountry");
              const options = select && select.querySelectorAll("option");
              const defaultSelect = addonNode.querySelector("#MadrressCountry select");
              options &&
                options.forEach((option) => {
                  defaultSelect && defaultSelect.appendChild(option);
                });
              this.setupCountries();
              defaultSelect.value = defaultSelect && defaultSelect.dataset.default;
            })
            .catch(console.error);
        }
      },
    });
    addEventDelegate({
      selector: this.selectors.closeAddonButton,
      context: this.cartWrapper,
      handler: this.close.bind(this),
    });
    addEventDelegate({
      selector: this.selectors.calcShippingButton,
      context: this.cartWrapper,
      handler: this.calcShipping.bind(this),
    });
    // O cupom agora fica aplicado no carrinho (nao so no localStorage), entao o campo
    // comeca vazio e o indicador so acende quando ha cupom ativo.
    if (cartDiscountCode) {
      const code = localStorage.getItem(this.discountCodeKey);
      if (code && cartDiscountCodeNoti) {
        cartDiscountCodeNoti.style.display = "inline";
      }
    }

    addEventDelegate({
      event: "click",
      context: this.cartWrapper,
      selector: "[data-remove-discount]",
      handler: (event, target) => {
        event.preventDefault();
        this.removeDiscount(target.dataset.removeDiscount);
      },
    });
    if (devliveryTime) {
      const code = localStorage.getItem(this.deliveryCodeKey);
      if (code) devliveryTime.value = code;
    }
    this.saveAddonValue();
    const today = new Date().toISOString().slice(0, 16);
    const deliveryTimeElm = this.querySelector("#delivery-time");
    if (deliveryTimeElm) deliveryTimeElm.min = today;
  }

  removeActiveAllButton() {
    const triggerButtons = this.querySelectorAll(this.selectors.triggerAddonButton);
    triggerButtons && triggerButtons.forEach((button) => button.classList.remove("active"));
  }

  setupCountries() {
    if (this.initAddress) return;
    if (Shopify && Shopify.CountryProvinceSelector) {
      new Shopify.CountryProvinceSelector("AddressCountry", "AddressProvince", {
        hideElement: "AddressProvinceContainer",
      });
      this.initAddress = true;
    }
  }

  close(event) {
    event.preventDefault();
    this.openAddon.classList.remove("open");
    this.cartOverlay && this.cartOverlay.classList.remove("open");
    this.removeActiveAllButton();
    this.openAddon = null;
  }

  calcShipping(event) {
    event.preventDefault();
    const actionsWrapper = event.target.closest(".m-cart-addon__action");
    actionsWrapper.classList.add("m-spinner-loading");
    const zipCode = this.domNodes.zipCode && this.domNodes.zipCode.value && this.domNodes.zipCode.value.trim();
    const country = this.domNodes.country.value;
    const province = this.domNodes.province.value;
    this.domNodes.shippingMessage.classList.remove("error");
    this.domNodes.shippingMessage.innerHTML = "";
    const showDeliveryDays = actionsWrapper.dataset.showDeliveryDays === "true";
    fetch(
      `${this.rootUrl}cart/shipping_rates.json?shipping_address%5Bzip%5D=${zipCode}&shipping_address%5Bcountry%5D=${country}&shipping_address%5Bprovince%5D=${province}`
    )
      .then((res) => res.json())
      .then((res) => {
        if (res && res.shipping_rates) {
          const { shipping_rates } = res;
          const { shippingRatesResult, noShippingRate } = MinimogStrings;
          if (shipping_rates.length > 0) {
            actionsWrapper.classList.remove("m-spinner-loading");
            const shippingLabel = document.createElement("P");
            shippingLabel.classList.add("m-cart-addon__shipping-rate--label");
            shippingLabel.innerHTML = `${shippingRatesResult.replace("{{count}}", shipping_rates.length)}:`;
            this.domNodes.shippingMessage.appendChild(shippingLabel);
            shipping_rates.map((rate) => {
              const { deliveryOne = "Day", deliveryOther = "Days" } = actionsWrapper.dataset;
              let deliveryDays = "";
              if (rate.delivery_days.length > 0 && showDeliveryDays) {
                let textDay = deliveryOne;
                const firstDeliveryDay = rate.delivery_days[0];
                const lastDeliveryDay = rate.delivery_days.at(-1);
                if (firstDeliveryDay > 1) textDay = deliveryOther;
                if (firstDeliveryDay === lastDeliveryDay) {
                  deliveryDays = `(${firstDeliveryDay} ${textDay})`;
                } else {
                  deliveryDays = `(${firstDeliveryDay} - ${lastDeliveryDay} ${textDay})`;
                }
              }
              const shippingRateItem = document.createElement("P");
              shippingRateItem.classList.add("m-cart-addon__shipping-rate--item");
              shippingRateItem.innerHTML = `${rate.name}: <span>${rate.price} ${Shopify.currency.active}</span> ${deliveryDays}`;
              this.domNodes.shippingMessage.appendChild(shippingRateItem);
            });
          } else {
            actionsWrapper.classList.remove("m-spinner-loading");
            this.domNodes.shippingMessage.innerHTML = `<p>${noShippingRate}</p>`;
          }
        } else {
          actionsWrapper.classList.remove("m-spinner-loading");
          Object.entries(res).map((error) => {
            this.domNodes.shippingMessage.classList.add(error[0] && error[0].toLowerCase());
            const message = `${error[1][0]}`;
            const shippingRateError = document.createElement("P");
            shippingRateError.classList.add("m-cart-addon__shipping-rate--error");
            shippingRateError.innerHTML = `${message}<sup>*</sup>`;
            this.domNodes.shippingMessage.appendChild(shippingRateError);
          });
        }
      })
      .catch(console.error);
  }

  saveAddonValue() {
    addEventDelegate({
      event: "click",
      context: this.cartWrapper,
      selector: this.selectors.saveAddonButton,
      handler: (event, target) => {
        event.preventDefault();
        const { cartDiscountCode, cartDiscountCodeNoti, devliveryTime } = this.domNodes;
        if (target.dataset.action === "coupon" && cartDiscountCode) {
          const code = cartDiscountCode.value.trim().toUpperCase();
          if (!code) {
            this.setCouponMessage(window.MinimogStrings.couponEmpty, "error");
            return;
          }
          this.applyDiscount(code, target);
        }
        if (target.dataset.action === "note") {
          this.updateCartNote();
          this.close(event);
        }
        if (target.dataset.action === "delivery") {
          const code = devliveryTime.value;
          const isValidDate = Date.parse(code);
          if (isValidDate > Date.now()) {
            localStorage.setItem(this.deliveryCodeKey, code);
            this.close(event);
          } else {
            localStorage.setItem(this.deliveryCodeKey, "");
            devliveryTime.value = "";
            window.MinimogTheme.Notification.show({
              target: this.querySelector(".m-cart-addon-message-error"),
              method: "appendChild",
              type: "error",
              message: window.MinimogStrings.valideDateTimeDelivery,
              last: 3000,
              sticky: false,
            });
          }
        }
      },
    });
  }

  updateCartNote() {
    const cartNoteValue = this.domNodes.cartNote.value;
    const body = JSON.stringify({ note: cartNoteValue });
    fetch(`${window.MinimogSettings.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  }

  getCart() {
    return fetch(`${this.rootUrl}cart.js`).then((response) => response.json());
  }

  setCouponMessage(text, type) {
    const messageNode = this.cartWrapper.querySelector("[data-coupon-message]");
    if (!messageNode) return;
    messageNode.textContent = text || "";
    messageNode.classList.remove("is-error", "is-success");
    if (text) messageNode.classList.add(type === "error" ? "is-error" : "is-success");
  }

  // Codigos que a Shopify de fato reconheceu neste carrinho, em maiusculas.
  // Prefere cart.discount_codes; cai para as discount applications quando ele nao vem.
  getAppliedCodes(cart) {
    if (Array.isArray(cart.discount_codes)) {
      return cart.discount_codes.filter((d) => d.applicable !== false).map((d) => String(d.code).toUpperCase());
    }
    // Fallback: cart_level_discount_applications so cobre cupons de nivel de pedido.
    // Cupons de escopo de produto ficam alocados nas linhas -- sem olhar para elas um
    // cupom valido seria reportado como invalido e removido logo em seguida.
    const codes = new Set();
    (cart.cart_level_discount_applications || []).forEach((d) => codes.add(String(d.title).toUpperCase()));
    (cart.items || []).forEach((item) => {
      (item.line_level_discount_allocations || []).forEach((allocation) => {
        const application = allocation.discount_application;
        if (application && application.title) codes.add(String(application.title).toUpperCase());
      });
    });
    return Array.from(codes);
  }

  // Aplica ou remove cupons via /cart/update.js. `codes` vazio limpa todos.
  updateDiscounts(codes) {
    const body = JSON.stringify({ discount: codes.join(",") });
    return fetch(`${window.MinimogSettings.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } }).then(
      (response) => response.json()
    );
  }

  refreshCart(cart) {
    const cartDrawer = document.querySelector("m-cart-drawer");
    if (this.isCartPage) {
      window.location.href = window.MinimogSettings.routes.cart;
      return;
    }
    if (cartDrawer) {
      cartDrawer.onCartDrawerUpdate();
      cartDrawer.classList.toggle("m-cart--empty", cart.item_count === 0);
    }
    window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, cart);
  }

  applyDiscount(code, target) {
    const { cartDiscountCode, cartDiscountCodeNoti } = this.domNodes;
    const actionsWrapper = target && target.closest(".m-cart-addon__action");
    actionsWrapper && actionsWrapper.classList.add("m-spinner-loading");
    this.setCouponMessage("", null);

    // Mantem os cupons ja aplicados: a Shopify aceita varios separados por virgula.
    this.getCart()
      .then((current) => {
        const existing = this.getAppliedCodes(current);
        if (existing.includes(code)) {
          this.setCouponMessage(window.MinimogStrings.couponAlreadyApplied, "error");
          return null;
        }
        return this.updateDiscounts([...existing, code]);
      })
      .then((cart) => {
        if (!cart) return;
        const applied = this.getAppliedCodes(cart);
        if (!applied.includes(code)) {
          // A Shopify responde 200 e deixa o codigo no carrinho como applicable:false.
          // Reenvia so os cupons validos para nao levar lixo ate o checkout.
          this.setCouponMessage(window.MinimogStrings.couponInvalid, "error");
          return this.updateDiscounts(applied).then(() => undefined);
        }
        localStorage.setItem(this.discountCodeKey, code);
        if (cartDiscountCodeNoti) cartDiscountCodeNoti.style.display = "inline";
        if (cartDiscountCode) cartDiscountCode.value = "";
        this.setCouponMessage(window.MinimogStrings.couponApplied.replace("{{ code }}", code), "success");
        this.refreshCart(cart);
      })
      .catch(() => {
        this.setCouponMessage(window.MinimogStrings.couponError, "error");
      })
      .finally(() => {
        actionsWrapper && actionsWrapper.classList.remove("m-spinner-loading");
      });
  }

  removeDiscount(code) {
    const { cartDiscountCodeNoti } = this.domNodes;
    const upper = String(code).toUpperCase();
    this.getCart()
      .then((current) => this.updateDiscounts(this.getAppliedCodes(current).filter((c) => c !== upper)))
      .then((cart) => {
        if (this.getAppliedCodes(cart).length === 0) {
          localStorage.removeItem(this.discountCodeKey);
          if (cartDiscountCodeNoti) cartDiscountCodeNoti.style.display = "none";
        }
        this.setCouponMessage("", null);
        this.refreshCart(cart);
      })
      .catch((e) => console.error(e));
  }
}

customElements.define("m-cart-addons", MCartAddons);
